// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"135":"143be004","580":"ba777b1b","675":"9c67d5a4","787":"01d167d2","808":"1ff36a6f","968":"241052ee"}[chunkId] + ".chunk.js";
};